import { Button, useTheme } from "@material-ui/core";

import { useThemeStyles } from "../../../styles/themes";

const RepaymentMethodV1 = (props) => {
  const { handleSetupMandate, handleShowLinkBank } = props;
  const classes = useThemeStyles();
  const theme = useTheme();

  return (
    <>
      <div>
        <p className={`${classes.title} title`}>Set Repayment Method</p>
        <p
          className={`${classes.subtitle} sub-title-v2`}
          style={{ color: theme.colors.colorPrimaryDarker }}
        >
          Please enter your <b>debit card</b> information. Credit cards are not supported.
        </p>
      </div>

      <div>
        <div className="form-control-holder" style={{ marginBottom: "16px" }}>
          <p className="small">
            Your selected debit card will be used to automatically collect your upcoming repayment(s).
          </p>
          <p className="small">
            We will redirect you to a secure page where you can safely enter your debit card details.
          </p>
        </div>

        <p className="small" style={{ display: "flex", gap: "4px" }}>
          <span style={{ color: theme.colors.colorPrimaryDarker, fontWeight: 700 }}>NOTE:</span>
          <span><b>RM 20.00 (auto-refundable)</b> will be deducted to verify and link your debit card.</span>
        </p>

        <div className="card-provider-holder" style={{ marginTop: "16px" }}>
          <img src="/images/master-visa.png" alt="mastercard-visa" className="cards-logo" />
        </div>

        <div className="action-holder" style={{ textAlign: "center" }}>
          <Button className={`${classes.btnContained} btn-next`} variant="contained" color="primary" onClick={handleSetupMandate}>
            Continue
          </Button>

          <p className="small" style={{ fontWeight: 700, marginTop: "16px" }}>or</p>

          <div style={{ marginTop: "16px" }}>
            <p className="small" style={{ color: theme.colors.colorPrimaryDarker }}>Don’t have a Debit Card?</p>
            <Button className={`${classes.btnContained} btn-next`} variant="outlined" onClick={handleShowLinkBank} style={{ marginTop: "8px" }}>
              Link your Bank Account
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default RepaymentMethodV1;
